import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { DEFECTDOJO_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from '../catalog/cells';
import { defectdojoColumns } from '../catalog/columns';
import { TypedCatalogPage } from '../catalog/TypedCatalogPage';
import { EntityDefectDojoSendersCell } from './DefectDojoCells';

const columns = defectdojoColumns<CatalogTableRow>(
  row => <EntityArgoAppsCell entity={row.entity} />,
  row => <EntityDefectDojoSendersCell entity={row.entity} />,
);

export const DefectDojoPage = () => (
  <TypedCatalogPage
    section="defectdojo"
    title="DefectDojo"
    subtitle="Реестр уязвимостей: находки проверок безопасности пайплайнов команд (gitleaks, semgrep, trivy)"
    kind="component"
    type={DEFECTDOJO_TYPE}
    columns={columns}
    create={{ title: 'Новый DefectDojo', to: routes.newDefectDojo }}
    support="DefectDojo ставится компонентом кластера (галочка «DefectDojo» шаблона «Новый Kubernetes-кластер») или позже шаблоном «DefectDojo» в кластер без него; база — в кластере PostgreSQL платформы (по умолчанию infra). Кластер без своего DefectDojo при создании выбирает чужой инстанс — туда его пайплайны и шлют отчёты (джоба app:defectdojo компонента app-security). Находки сервиса — на его вкладке Security, вход в DefectDojo — через GitLab платформы."
    emptyContent={
      <EmptyState
        missing="data"
        title="DefectDojo пока нет"
        description="DefectDojo появляется вместе с кластером (галочка «DefectDojo» шаблона «Новый Kubernetes-кластер») или ставится шаблоном «DefectDojo» в существующий кластер."
      />
    }
  />
);
